import * as React from 'react'

export default class ErrorBoundary extends React.Component {
  public state = {
    hasError: false
  }

  public componentDidCatch(error: any, info: any) {
    this.setState({ hasError: true })

    //TODO log errors
    console.log(error)
    console.log(info)
  }

  public render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>
    }

    return this.props.children
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.tsx